import { TextCell } from '@common/components/TextCell';

interface NameCellProps {
	name: string;
}

export const NameCell = ({ name }: NameCellProps) => {
	return <TextCell value={name} weight='semibold' />;
};
